///https://github.com/revolunet/angular-google-analytics
(
	function() {
		angular.module('hhv.analystics', ['angular-google-analytics'])
			.config(['AnalyticsProvider', function(AnalyticsProvider) {
				AnalyticsProvider
					.setPageEvent('$processedStateChangeSuccess')
					.ignoreFirstPageLoad(true)
					.useEnhancedLinkAttribution(true)
					.setAccount('UA-71396847-1');
			}])
			.run(['Analytics', '$rootScope', '$timeout', function(Analytics, $rootScope, $timeout){
				if (window.performance) {
					$rootScope.$on('$viewContentLoading', function(event, viewConfig){
						var t0 = performance.now();
						var offLoadedHandler = $rootScope.$on('$viewContentLoaded', function(event){
							var t1 = performance.now();
							Analytics.trackTimings('View', 'load', t1-t0, viewConfig.params);
							offLoadedHandler();
						});
					});
				}
				$rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams){
					if(toState.name !== 'sub.search')
						$timeout(function(){
							$rootScope.$emit('$processedStateChangeSuccess', event, toState, toParams, fromState, fromParams);
						});
				});
				$rootScope.$on('$viewContentLoaded', function(event){

				});
			}]);
})();